import { Folder, Status } from "../../redux/interfaces/folder.types.ts";

/**
 * Subfolders whose completeness gates the MULTIREPORT.
 *
 * Espejo 1:1 de `multireport_relevant_subfolders` (mb-multiexpediente,
 * `apps/docvault/utils`) y de `MULTIREPORT_RELEVANT_SUBFOLDERS` (mb_platform,
 * `services/multiexpediente/multiexpediente_service.py`), que es lo que realmente
 * valida el backend al generar/previsualizar el multireporte.
 *
 * Los subfolders de contrato (`lease-contract-*`, `owner-representative*`), los
 * participantes adicionales (`-cja`) y los arrendadores extra (`landlord-pf/pm`)
 * alimentan el reporte pero NO lo bloquean: sus documentos pendientes no deben
 * desactivar los botones de multireporte.
 */
export const MULTIREPORT_RELEVANT_SUBFOLDERS: string[] = [
  "tenant-pf",
  "tenant-pm",
  "guarantor-pf",
  "guarantor-pm",
  "guarantor-investigation-pf",
  "guarantor-investigation-pm",
  "collateral",
];

/**
 * True cuando TODOS los subfolders relevantes para el multireporte están en `valid`.
 *
 * Un subfolder es `valid` solo si todos sus requisitos lo están (lo resuelve el
 * backend en `Subfolder.update_status`), así que basta con mirar su estatus.
 *
 * Devuelve `false` cuando el expediente no tiene ningún subfolder relevante
 * (expedientes solo-contrato / CJA): ahí no hay multireporte que generar, igual que
 * en `is_folder_ready_for_multireport` del backend.
 */
export const areMultireportSubfoldersReady = (folder: Folder): boolean => {
  const relevantSubfolders = (folder.subfolders || []).filter((subfolder) =>
    MULTIREPORT_RELEVANT_SUBFOLDERS.includes(
      subfolder.slug || subfolder.template?.slug || "",
    ),
  );

  if (relevantSubfolders.length === 0) return false;

  return relevantSubfolders.every(
    (subfolder) => subfolder.status === Status.Valid,
  );
};
